const theme = {
  palette: {
    dark_blue: 'hsl(214, 100%, 28%)',
    blue: 'hsl(214, 90%, 34%)',
    light_blue: 'hsl(214, 80%, 80%)',
    pale_blue: 'hsl(214, 60%, 90%)',
    green: 'hsl(165, 100%, 35%)',
    yellow: 'hsl(44, 100%, 50%)',
    pale_yellow: 'hsl(44, 80%, 80%)',
    red: 'hsl(14, 90%, 50%)',
    pale_red : 'hsl(14, 80%, 80%)',
    black: 'hsl(0, 0%, 15%)',
    dark_grey: 'hsl(0, 0%, 50%)',
    grey: 'hsl(0, 0%, 85%)',
    light_grey: 'hsl(0, 0%, 96%)',
    white: 'hsl(0, 100%, 100%)',
  },
  breakpoints: {
    mobile: '750px'
  }
}
export default theme
